import { css, StyleSheet } from 'aphrodite'
import * as React from 'react'

import style from '../utils/style'
import Layout from './layout'
import withStyle from './withStyle'

const styles = StyleSheet.create({
  main: {
    textAlign: 'center',
    position: 'absolute',
    left: '50%',
    top: 24,
    bottom: 24,
    width: 'calc(100vw - 48px)',
    maxWidth: 900,
    transform: 'translateX(-50%)',
    background: style.darkGrey,
    border: style.border,
    overflow: 'hidden',

    '@media (max-height: 560px)': {
      top: 8,
      bottom: 8,
      width: 'calc(100vw - 16px)',
    },
  },
  compact: {
    top: '50%',
    bottom: 'auto',
    width: 'calc(100vw - 48px)',
    maxWidth: 520,
    maxHeight: 'calc(100vh - 48px)',
    transform: 'translate(-50%, -50%)',

    '@media (max-height: 560px)': {
      top: '50%',
      bottom: 'auto',
      width: 'calc(100vw - 16px)',
      maxHeight: 'calc(100vh - 16px)',
    },
  },
  backdrop: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(128, 128, 128, 0.5)',
    zIndex: 1,
    overflow: 'hidden',
  },
  controls: {
    borderTop: `3px solid ${style.gold}`,
    flex: '0 0 auto',
  },
  control: {
    borderRight: `3px solid ${style.gold}`,
    padding: 20,
    cursor: 'pointer',
    background: 'rgba(133, 113, 0, .12)',
    color: style.textColor,
    ':hover': {
      background: style.gold,
      color: style.darkGrey,
    },
    ':last-child': {
      borderRight: 0,
    },

    '@media (max-height: 560px)': {
      padding: 10,
    },
  },
  content: {
    padding: 20,
    minHeight: 0,
    overflow: 'auto',

    '@media (max-height: 560px)': {
      padding: 8,
    },
  },
  title: {
    flex: '0 0 auto',
    borderBottom: `3px solid ${style.gold}`,
    paddingBottom: 20,
    marginBottom: 0,

    '@media (max-height: 560px)': {
      marginTop: 8,
      paddingBottom: 8,
    },
  },
})

const DialogTitle = withStyle.className('DialogTitle', 'h2', styles.title)
const DialogContent = withStyle.classes(
  'DialogContent',
  props => <Layout {...props} grow />,
  styles.content,
)
const DialogControls = withStyle.classes(
  'DialogControls',
  props => <Layout {...props} direction="row" />,
  styles.controls,
)
const DialogControl = withStyle.classes(
  'DialogControl',
  props => <Layout {...props} grow />,
  styles.control,
)

interface IProps {
  compact?: boolean,
}

// make it pass props. maybe create withStyle HOC?
export default class Dialog extends React.Component<IProps, {}> {
  static Title = DialogTitle
  static Controls = DialogControls
  static Control = DialogControl
  static Content = DialogContent

  render() {
    return (
      <div className={css(styles.backdrop)}>
        <Layout classes={[styles.main, this.props.compact && styles.compact]}>
          {this.props.children}
        </Layout>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/ui/components/Dialog.tsx